import { useParams } from 'react-router-dom'
import { getRequest } from '../../../services/base'
import { downloadFileBlob } from '../../../utils/common'
import { NavContext } from '../../../context/global_context'
import { useContext } from 'react'

import { Dropdown, Button } from 'antd'
import {
  DownOutlined,
  ExportOutlined /* , MenuOutlined */,
} from '@ant-design/icons'
import LinkWithStatus from '../../common/LinkWithStatus'

const DownloadInlines = ({ isButton = true }) => {
  let { vehicle } = useParams()
  const [navState, navDispatch] = useContext(NavContext)

  const downloadInlineCsv = async ({ key: file_type }) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Downloading Inline ${file_type} csv file.`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/inline_connection/download/?vehicle=${vehicle}&file_type=${file_type}`,
      true,
      true
    )
    if (res?.msg) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `${vehicle}_inline_${file_type}.csv`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  const items = [
    {
      key: 'suffix',
      label: 'Download Suffix',
      // icon: <MenuOutlined/>,
      icon: <ExportOutlined />,
    },
    {
      key: 'prefix',
      label: 'Download Prefix',
      // icon: <MenuOutlined/>,
      icon: <ExportOutlined />,
    },
  ]

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      menu={{
        items,
        onClick: downloadInlineCsv,
      }}
    >
      {isButton ? (
        <>
          {/* TODO: It look like this condition is never used, Check & delete LinkWithStatus or replace it with the commented code */}
          {/* <Button>
                Export
                <DownOutlined />
              </Button> */}
          <LinkWithStatus
            href={`/administration/system/new`}
            className={
              'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
            }
            title="Export Prefix/Suffix"
            onClickFunc={() => {}}
          />
        </>
      ) : (
        <Button type="link" className="link-button export-prefix-suffix">
          Download Prefix/Suffix
        </Button>
      )}
    </Dropdown>
  )
}

export default DownloadInlines
